import { renderColumn } from './Column';
import type { ColumnType } from '../Table';

const buildGetValue = (column: DynamicColumnType) => {
  return (row: Record<string, any>) => renderColumn(row, column);
};

export const buildDynamicColumn = <T extends Record<string, any>>(
  column: DynamicColumnType
): ColumnType<T> => {
  return {
    header: column.label,
    cellContentStyle: column.style,
    getValue: buildGetValue(column),
    headerStyle: column.width
      ? { width: column.width, minWidth: column.width }
      : {},
    sortName:
      column.sort_key || column.sortable
        ? column.sort_key || column.key
        : undefined,
  };
};

export const buildDynamicColumns = <T extends Record<string, any>>(
  data: DynamicColumnType[]
): ColumnType<T>[] => {
  return data.map(column => buildDynamicColumn(column));
};
